class GlobalMessageListController {
  constructor(GlobalMessageService, DEBUG) {
    "ngInject";
    this.GlobalMessageService = GlobalMessageService;
    this.DEBUG = DEBUG;
  }

  get messages() {
    return this.GlobalMessageService.messages;
  }

  clearMessageIndex(idx) {
    return this.GlobalMessageService.clearMessageIndex(idx);
  }
}

export default GlobalMessageListController;
